import React from "react";

const Blogs = () => {
  return (
    <div>
      <div className="container">
        <h2 className="text-center my-5">Cooming Soon</h2>
      </div>
    </div>
  );
};

export default Blogs;
